<template>
    <scroll-page :loading="loading"
                 :offset="offset"
                 :no-data="noData"
                 @load="load">
        <!-- 空状态：人性化文案 -->
        <div v-if="!loading && noData && articles.length === 0" class="article-empty">
            <p class="empty-text">{{ emptyText }}</p>
        </div>
        <article-item v-else v-for="article in articles"
                      :key="article.id"
                      v-bind="article">
        </article-item>
    </scroll-page>
</template>

<script>
    import ArticleItem from '@/components/article/ArticleItem'
    import ScrollPage from '@/components/scrollpage'
    /*
    引入文件时，../以该目录为基准，往上跳一个目录，ArticleScrollPage.vue目录为common，往上跳一个目录为components，需要再往上跳到src才能引入api
    */
    import {getArticles} from '@/api/article'
    import {getToken} from "@/request/token";
    import {Message} from "element-ui";

    export default {
        name: "ArticleScrollPage",
        props: {
            offset: {
                type: Number,
                default: 0
            },
            query: {
                type: Object,
                default() {
                    return {}
                },
            }
        },
        computed: {
            emptyText() {
                const hasRange = this.query.startYear != null && this.query.startMonth != null &&
                    this.query.endYear != null && this.query.endMonth != null;
                const hasMonth = this.query.year != null && this.query.month != null;
                const hasTitle = this.query.title != null && String(this.query.title).trim() !== '';
                if (hasTitle) return "没有找到标题包含「" + this.query.title + "」的文章";
                if (hasRange) return "该时间段还没有文章哦";
                if (hasMonth) return "这个月还没有文章哦，去看看其他月份吧";
                return "还没有文章哦";
            }
        },
        watch: {
            query: {
                handler() {
                    this.articles = [];
                    this.PageParams.page = 1;
                    this.noData = true;
                    if (this.checkLogin()) {
                        this.getArticles();
                    }
                },
                deep: true
            }
        },
        created() {
          if (this.checkLogin()) {
            this.getArticles();
          }
        },
        data() {
            return {
                loading: false,
                noData: true,
                //分页参数
                PageParams: {
                    page: 1,
                    pageSize: 5,
                    tagId: null,
                    categoryId: null,
                    year: null,
                    month: null,
                    startYear: null,
                    startMonth: null,
                    endYear: null,
                    endMonth: null,
                    title: null
                },
                //文章列表
                articles: []
            }
        },
        methods: {
          checkLogin() {
            if (!getToken()) {
              this.$router.push({path: "/login"})
              return false;
            }
            return true;
          },
            load() {
                //下拉触发分页的时候,调用接口加载
                this.getArticles();
            },
            getArticles() {
                const that = this;
                that.loading = true;
                this.PageParams.tagId = this.query.tagId;
                this.PageParams.categoryId = this.query.categoryId;
                this.PageParams.year = this.query.year ?? null;
                this.PageParams.month = this.query.month ?? null;
                this.PageParams.startYear = this.query.startYear ?? null;
                this.PageParams.startMonth = this.query.startMonth ?? null;
                this.PageParams.endYear = this.query.endYear ?? null;
                this.PageParams.endMonth = this.query.endMonth ?? null;
                this.PageParams.title = this.query.title != null && String(this.query.title).trim() !== '' ? String(this.query.title).trim() : null;
                getArticles(this.PageParams).then((res) => {
                    if (!res.data.success) {
                        this.$message.error(res.data.msg);
                        return;
                    }
                    const list = res.data.data || [];
                    this.noData = list.length === 0;
                    this.articles = this.articles.concat(list);
                    this.PageParams.page += 1;
                }).catch(() => {
                    this.$message.error("网络好像有点慢，稍后再试一下吧");
                }).finally(() => {
                    that.loading = false;
                });
            }
        },
        components: {
            'article-item': ArticleItem,
            'scroll-page': ScrollPage
        }
    }
</script>

<style scoped>
    .el-card {
        border-radius: 6px;
    }

    .el-card:not(:first-child) {
        margin-top: 10px;
    }

    .article-empty {
        text-align: center;
        padding: 48px 20px;
    }

    .article-empty .empty-text {
        color: rgba(203, 213, 225, 0.85);
        font-size: 15px;
        margin: 0;
    }
</style>
